var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-container"},[_c('img',{attrs:{"src":require("@/assets/images/emptydata4.gif"),"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.hint))])])
}
var staticRenderFns = []

export { render, staticRenderFns }